import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';

export default function Footer() {
  const { t } = useApp();
  const year  = new Date().getFullYear();

  return (
    <footer style={{ borderTop: '1px solid var(--border)', background: 'var(--surface)', padding: '40px 0 24px', marginTop: '60px' }}>
      <div className="container">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '32px', marginBottom: '32px' }}>
          {/* Brand */}
          <div>
            <div style={{ fontSize: '20px', fontWeight: 700, marginBottom: '8px' }}>
              <span style={{ color: 'var(--text)' }}>Kajer</span><span style={{ color: 'var(--brand)' }}>Bazar</span>
            </div>
            <p style={{ fontSize: '13px', color: 'var(--text3)', lineHeight: 1.6 }}>
              Bangladesh's work marketplace — connecting seekers, posters, and employers.
            </p>
          </div>

          {/* For seekers */}
          <div>
            <div style={{ fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--text3)', marginBottom: '12px' }}>For seekers</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Link to="/jobs"         style={{ fontSize: '13px', color: 'var(--text2)', textDecoration: 'none' }}>{t('nav_find_job')}</Link>
              <Link to="/post-seek-ad" style={{ fontSize: '13px', color: 'var(--text2)', textDecoration: 'none' }}>{t('post_seek')}</Link>
              <Link to="/wallet"       style={{ fontSize: '13px', color: 'var(--text2)', textDecoration: 'none' }}>{t('nav_wallet')}</Link>
            </div>
          </div>

          {/* For posters */}
          <div>
            <div style={{ fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--text3)', marginBottom: '12px' }}>For employers</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Link to="/find-hire" style={{ fontSize: '13px', color: 'var(--text2)', textDecoration: 'none' }}>{t('nav_find_hire')}</Link>
              <Link to="/post-job"  style={{ fontSize: '13px', color: 'var(--text2)', textDecoration: 'none' }}>{t('nav_post_job')}</Link>
              <Link to="/register"  style={{ fontSize: '13px', color: 'var(--text2)', textDecoration: 'none' }}>Create account</Link>
            </div>
          </div>

          {/* Browse */}
          <div>
            <div style={{ fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--text3)', marginBottom: '12px' }}>Browse</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {['Technical','Domestic','Freelance','Tutor','Creative'].map(cat => (
                <Link key={cat} to={`/jobs?category=${cat}`} style={{ fontSize: '13px', color: 'var(--text2)', textDecoration: 'none' }}>{cat}</Link>
              ))}
            </div>
          </div>
        </div>

        <div style={{ borderTop: '1px solid var(--border)', paddingTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
          <div style={{ fontSize: '12px', color: 'var(--text3)' }}>© {year} KajerBazar. All rights reserved.</div>
          <div style={{ fontSize: '12px', color: 'var(--text3)' }}>Made with ❤️ for Bangladesh 🇧🇩</div>
        </div>
      </div>
    </footer>
  );
}
